import Cookie from 'js-cookie';
import qs from 'qs';

const B2B_KONTUR = 'b2b_kontur';

export default function makeKmData() {
  const eventObj = {
    obj: {
      result: 'success',
    },
  };

  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const srcmarker2Cookie = Cookie.get('srcmarker2');

  if (
    query.srcmarker2 === B2B_KONTUR ||
    (srcmarker2Cookie && srcmarker2Cookie.includes(B2B_KONTUR))
  ) {
    return {
      obj: {
        result: 'success',
        srcmarker2: B2B_KONTUR,
      },
    };
  }

  return eventObj;
}
